export default __webpack_public_path__ + "static/8338-895f9d45d6fee981692554254a1ffb35.jpg";